import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import travel2 from "../assets/travel2.jpg";
import Footer from "../Components/Footer";
import AboutUs from "../Components/AboutUs";

const About = () => {
  return (
    <div>
      <Navbar />
      <Hero
        cName="hero-middle"
        heroImg={travel2}
        title="About"
        btnClass="hide"
      />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default About;
